import { render, staticRenderFns } from "./ProductPurchaseInformation.vue?vue&type=template&id=264b75a2&"
import script from "./ProductPurchaseInformation.vue?vue&type=script&lang=js&"
export * from "./ProductPurchaseInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports